import { ReactNode } from 'react';
import Sidebar from '.';
import './styles.scss';

export const WithNavBar = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <Sidebar content={children} />
    </>
  );
};
